import React, { useEffect, useState } from 'react';
import './CreateNewWorkspaces.css';
import { MdKeyboardBackspace } from 'react-icons/md';
import { AutoComplete, Button, Input } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { RxCross2 } from 'react-icons/rx';
import { MdAdd } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { workspaces_TeamMember_ActionHandler } from '../../../Redux/Actions/user/WorkspacesTeamMember';
import { workspaces_Create_ActionHandler } from '../../../Redux/Actions/user/WorkspaceCreate';
import {
    workspace_Update_api,
    workspace_Details_Api,
} from '../../../Redux/Apis/user/ApiConfig';
import Loader from '../../../Components/Loader/Loader';

const SearchIcon = '/assets/SearchIcon.svg';
const Workspaces_icon = '/assets/workspace_Icon.svg';
const ImageIcon = '/assets/Image-icon.svg';
const blackLock = '/assets/black-lock.svg';
const boldMember = '/assets/bold-people.svg';
const profile = '/assets/profile.svg';

const CreateNewWorkspaces = () => {
    let Navigate = useNavigate();
    let dispatch = useDispatch();
    let { id } = useParams();

    const [selectedValue, setSelectedValue] = useState('');
    const [workspaceName, setWorkspaceName] = useState(null);
    const [accessLevel, setAccessLevel] = useState('');
    const [workspaceId, setWorkspaceId] = useState([]);
    const [addedMembers, setAddedMember] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [duplicateData, setDuplicateData] = useState('');
    const [checkMember, setCheckMember] = useState(false);

    const [teamMember, setTeamMember] = useState([]);

    const teamMemberData = useSelector(
        (state) => state?.workspaces_TeamMember_Data?.workspace_TeamMember_data
    );

    // const workspaceCreate = useSelector(
    //   (state) => state?.workspaces_Create_Data?.workspace_create_data
    // );

    const workspaceCreateLoader = useSelector(
        (state) => state?.workspaces_Create_Data?.loader
    );

    const handleAccessLevelChange = (event) => {
        setAccessLevel(event.target.value);
    };
    const fetchWorkspaceData = async () => {
        try {
            const { data } = await workspace_Details_Api(id);
            const { name, access_type } = data.data;
            setWorkspaceName(name);
            setAccessLevel(access_type);
        } catch (err) {}
    };

    useEffect(() => {
        if (id) {
            fetchWorkspaceData();
        }
        dispatch(workspaces_TeamMember_ActionHandler());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (teamMemberData?.data?.length) {
            setTeamMember(teamMemberData?.data);
        }
        // eslint-disable-next-line
    }, [teamMemberData?.data]);

    const handleAddedMember = (index, item) => {
        setErrorMessage('');
        setSelectedValue('');
        setCheckMember(!checkMember);

        const updatedMembers = [...addedMembers];
        const isDuplicate = addedMembers.some(
            (member) => member === item?.first_name + ' ' + item?.last_name
        );

        setDuplicateData('');
        if (!isDuplicate) {
            const memberName = item?.first_name + ' ' + item?.last_name;
            updatedMembers.splice(index, 0, memberName);
            setAddedMember(updatedMembers);
            setWorkspaceId([item?.id, ...workspaceId]);
        } else {
            setDuplicateData('Member already exists.');
        }
    };
    useEffect(() => {
        setSelectedValue('');
    }, [checkMember]);

    const handleUserRemove = (index) => {
        const updatedMembers = [...addedMembers];
        updatedMembers.splice(index, 1);
        setAddedMember(updatedMembers);
    };

    const options = teamMember?.map((item, index) => ({
        key: item?.id,
        value: item?.first_name + ' ' + item?.last_name,
        label: (
            <div
                className='member-added-dropdown'
                key={item?.id}
                onClick={() => {
                    handleAddedMember(index, item);
                }}>
                <div className='member-added-dropdown-data'>
                    <img src={item.profile_picture} alt='' className='p-pic' />
                    <div>
                        <p>
                            {item?.first_name} {item?.last_name}
                        </p>
                        <p>{item?.first_name.toLowerCase()}@gmail.com</p>
                    </div>
                </div>
                <div>
                    <MdAdd />
                    <p>Add</p>
                </div>
            </div>
        ),
    }));

    const postWorkspaceData = async (body) => {
        try {
            await workspace_Update_api(body, id);
            Navigate('/workspaces');
        } catch (err) {}
    };

    const handleSubmit = () => {
        if (!workspaceName || !accessLevel || !workspaceId) {
            if (!workspaceName || !accessLevel || !workspaceId) {
                setErrorMessage('Please fill all the required fields.');
                return;
            } else {
                setErrorMessage('');
            }
        }
        if (id) {
            const body = {
                name: workspaceName,
                access_type: accessLevel,
            };
            postWorkspaceData(body);
        } else {
            let createData = {
                name: workspaceName,
                access_type: accessLevel,
                team_members: workspaceId,
            };

            dispatch(workspaces_Create_ActionHandler(createData, Navigate));
        }

        //gtm
        window.dataLayer.push({
            event: 'Create workspaces',
            buttonName: ' Create Workspaces',
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
        });
    };

    return (
        <div className='new_workspace_main workspace-container'>
            {workspaceCreateLoader && <Loader />}
            <div className='new_workspaces-container'>
                <h3>Create New Workspaces</h3>
                <div
                    className='new-workspace-back'
                    onClick={() => Navigate('/workspaces')}>
                    <MdKeyboardBackspace />
                    Back
                </div>
                <div className='new_workspaces_inner'>
                    <img src={Workspaces_icon} alt='' />
                    <h4>Workspaces</h4>
                </div>
                <div className='workspace-input-container'>
                    <div className='avatar-container'>
                        <img
                            className='circular-image'
                            src={ImageIcon}
                            alt=''
                        />
                    </div>
                    <div className='workspaces-input-field'>
                        <label>Workspace name</label>
                        <Input
                            placeholder='workspaces name'
                            onChange={(e) => {
                                setWorkspaceName(e.target.value);
                                setErrorMessage('');
                            }}
                            value={workspaceName || ''}
                        />
                        {errorMessage && (
                            <div className='error-message'>{errorMessage}</div>
                        )}
                    </div>
                </div>

                <div className='workspace-seprator'></div>

                <div className='add-workspace-member'>
                    {id ? null : (
                        <>
                            <div>
                                <img src={boldMember} alt='' />
                                <h4>Add team members</h4>
                            </div>

                            <div className='relative search-container autocomplete-div'>
                                <AutoComplete
                                    style={{ width: '100%' }}
                                    options={options}
                                    placeholder='Search members here... '
                                    value={selectedValue}
                                    onChange={(value) => {
                                        setSelectedValue(value);
                                    }}
                                    filterOption={(inputValue, option) => {
                                        const firstNameToCompare =
                                            option?.value || '';
                                        const filterResult =
                                            firstNameToCompare
                                                .toUpperCase()
                                                .indexOf(
                                                    inputValue.toUpperCase()
                                                ) !== -1;
                                        return filterResult;
                                    }}
                                />

                                <img
                                    src={SearchIcon}
                                    alt=''
                                    className='search-icon'
                                />
                                {selectedValue && (
                                    <RxCross2
                                        className='cross-member'
                                        onClick={() => {
                                            setSelectedValue(null);
                                            setDuplicateData('');
                                        }}
                                    />
                                )}
                            </div>

                            {errorMessage && (
                                <div className='error-message'>
                                    {errorMessage}
                                </div>
                            )}
                            {duplicateData && (
                                <div className='error-message'>
                                    {duplicateData}
                                </div>
                            )}

                            <div className='added-member_div'>
                                {!addedMembers.length ? (
                                    <div className='add-workspaces-email'>
                                        Please enter the member's name or email
                                        address to add.
                                    </div>
                                ) : (
                                    <p>Members</p>
                                )}
                                {addedMembers?.map((item, index) => (
                                    <>
                                        <div
                                            className='member-dropdwoan-main'
                                            key={index}>
                                            <div className='member-dropdown-data'>
                                                <img src={profile} alt='' />
                                                <div>
                                                    <p>{item}</p>
                                                    <p>{item + '@gmail.com'}</p>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() =>
                                                    handleUserRemove(index)
                                                }>
                                                <RxCross2 />
                                                <p>remove</p>
                                            </div>
                                        </div>
                                        <div className='memberadd-seprator'></div>
                                    </>
                                ))}
                            </div>

                            <div className='workspace-seprator'></div>
                        </>
                    )}
                    <div className='black-lock-access'>
                        <img src={blackLock} alt='' />
                        <p>Access</p>
                    </div>
                    <div className='access-workspaces'>
                        <div className='access-container'>
                            <div className='access-inner1'>
                                <h3>Hidden </h3>
                                <input
                                    type='radio'
                                    name='accessLevel'
                                    id='radioHidden'
                                    value='HIDDEN'
                                    checked={accessLevel === 'HIDDEN'}
                                    onChange={handleAccessLevelChange}
                                />
                            </div>
                            <div className='access-inner2'>
                                <p>
                                    Only you and the team members you add will
                                    be able to see this
                                </p>
                            </div>
                        </div>

                        <div className='access-container'>
                            <div className='access-inner1'>
                                <h3>Restricted </h3>
                                <input
                                    type='radio'
                                    name='accessLevel'
                                    id='radioRestricted'
                                    value='RESTRICTED'
                                    checked={accessLevel === 'RESTRICTED'}
                                    onChange={handleAccessLevelChange}
                                />
                            </div>
                            <div className='access-inner2'>
                                <p>
                                    All Account members will see the workspace
                                    but will only have access if they have been
                                    added.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className='create-workspace-btn'
                        onClick={handleSubmit}>
                        <Button className='main-api'>
                            {id ? `Update Workspace` : `Create Workspace`}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateNewWorkspaces;
